import React from 'react'
import BaseLayout from '../../admin/BaseLayout'
import IconifyIcon from '../../components/wrapper/IconifyIcon'
import { logEvent } from '../../config/firebase'
import './Resources.css'

const resources = [
  {
    name: 'Quantum Odds',
    category: 'Inteligência de mercado',
    handle: 'quantumodds.xyz',
    url: 'https://quantumodds.xyz/',
    icon: 'solar:chart-2-bold-duotone',
    description: 'Plataforma de inteligência de mercado onde os utilizadores podem negociar as suas convicções sobre o que vai acontecer.',
    action: 'Explorar Quantum Odds',
  },
  {
    name: 'PolyMidas',
    category: 'Bot Telegram',
    handle: '@polymarket_market_aim_bot',
    url: 'https://t.me/polymarket_market_aim_bot',
    icon: 'logos:telegram',
    description: 'Alertas e informação sobre os mercados da Polymarket diretamente no Telegram.',
    action: 'Abrir bot',
  },
  {
    name: 'Quantum Odds — Bot Telegram',
    category: 'Bot Telegram',
    handle: '@price_drop_ai_bot',
    url: 'https://t.me/price_drop_ai_bot',
    icon: 'logos:telegram',
    description: 'Bot da Quantum Odds para acompanhar odds e movimentos de mercado no Telegram.',
    action: 'Abrir bot',
  },
  {
    name: 'AI Midas',
    category: 'Análise de mercado',
    handle: 'aimidas.app',
    url: 'https://www.aimidas.app/pt-br',
    icon: 'solar:document-text-bold-duotone',
    description: 'Análises e investigação de mercado para aprofundar decisões com mais contexto.',
    action: 'Visitar site',
  },
  {
    name: 'Polybank',
    category: 'Gestor de portfólio',
    handle: 'polybank.aimidas.app',
    url: 'https://www.polybank.aimidas.app/',
    icon: 'solar:wallet-bold-duotone',
    description: 'Gestor de portfólio para acompanhar posições e resultados na Polymarket.',
    action: 'Abrir ferramenta',
  },
]

const Resources = () => {
  const trackResource = (resource) => {
    logEvent('resource_link_click', {
      resource: resource.name,
      destination: resource.handle,
    })
  }

  return (
    <BaseLayout>
      <main className="resources-page">
        <header className="resources-header">
          <span className="resources-eyebrow"><i /> ECOSSISTEMA FILTER MARKET</span>
          <h1>Recursos</h1>
          <p>Plataformas e ferramentas para acompanhar mercados, previsões e movimentos de preço.</p>
        </header>

        <section className="resources-grid" aria-label="Plataformas e ferramentas">
          {resources.map((resource, index) => (
            <article className="resource-card" key={resource.name}>
              <div className="resource-card-topline">
                <span className="resource-number">{String(index + 1).padStart(2, '0')}</span>
                <span className="resource-category">{resource.category}</span>
              </div>
              <div className="resource-title-row">
                <span className="resource-icon"><IconifyIcon icon={resource.icon} width="23" /></span>
                <div>
                  <h2>{resource.name}</h2>
                  <span>{resource.handle}</span>
                </div>
              </div>
              <p>{resource.description}</p>
              <a
                className="resource-link"
                href={resource.url}
                onClick={() => trackResource(resource)}
                rel="noopener noreferrer"
                target="_blank"
              >
                {resource.action}
                <IconifyIcon icon="solar:arrow-right-up-linear" width="17" />
              </a>
            </article>
          ))}
        </section>
      </main>
    </BaseLayout>
  )
}

export default Resources
